var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AbstractEndpoint = require('../endpoint');

var CharactersEndpoint = require('./characters');

var PvpEndpoint = require('./pvp');

var CommerceEndpoint = require('./commerce');

var accountBlob = require('./account-blob.js');

module.exports =
/*#__PURE__*/
function (_AbstractEndpoint) {
  "use strict";

  _inherits(AccountEndpoint, _AbstractEndpoint);

  function AccountEndpoint(client) {
    var _this;

    _classCallCheck(this, AccountEndpoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AccountEndpoint).call(this, client));
    _this.url = '/v2/account';
    _this.isAuthenticated = true;
    _this.cacheTime = 5 * 60;
    return _this;
  }

  _createClass(AccountEndpoint, [{
    key: "achievements",
    value: function achievements() {
      return new AchievementsEndpoint(this);
    }
  }, {
    key: "bank",
    value: function bank() {
      return new BankEndpoint(this);
    }
  }, {
    key: "characters",
    value: function characters(name) {
      return new CharactersEndpoint(this, name);
    }
  }, {
    key: "delivery",
    value: function delivery() {
      return new CommerceEndpoint(this).delivery();
    }
  }, {
    key: "dungeons",
    value: function dungeons() {
      return new DungeonsEndpoint(this);
    }
  }, {
    key: "dyes",
    value: function dyes() {
      return new DyesEndpoint(this);
    }
  }, {
    key: "finishers",
    value: function finishers() {
      return new FinishersEndpoint(this);
    }
  }, {
    key: "gliders",
    value: function gliders() {
      return new GlidersEndpoint(this);
    }
  }, {
    key: "home",
    value: function home() {
      var _this2 = this;

      return {
        cats: function cats() {
          return new HomeCatsEndpoint(_this2);
        },
        nodes: function nodes() {
          return new HomeNodesEndpoint(_this2);
        }
      };
    }
  }, {
    key: "inventory",
    value: function inventory() {
      return new InventoryEndpoint(this);
    }
  }, {
    key: "mailcarriers",
    value: function mailcarriers() {
      return new MailcarriersEndpoint(this);
    }
  }, {
    key: "masteries",
    value: function masteries() {
      return new MasteriesEndpoint(this);
    }
  }, {
    key: "mastery",
    value: function mastery() {
      var _this3 = this;

      return {
        points: function points() {
          return new MasteryPointsEndpoint(_this3);
        }
      };
    }
  }, {
    key: "materials",
    value: function materials() {
      return new MaterialsEndpoint(this);
    }
  }, {
    key: "minis",
    value: function minis() {
      return new MinisEndpoint(this);
    }
  }, {
    key: "mounts",
    value: function mounts() {
      var _this4 = this;

      return {
        skins: function skins() {
          return new MountSkinsEndpoint(_this4);
        },
        types: function types() {
          return new MountTypesEndpoint(_this4);
        }
      };
    }
  }, {
    key: "outfits",
    value: function outfits() {
      return new OutfitsEndpoint(this);
    }
  }, {
    key: "pvp",
    value: function pvp() {
      return new PvpEndpoint(this, true);
    }
  }, {
    key: "raids",
    value: function raids() {
      return new RaidsEndpoint(this);
    }
  }, {
    key: "recipes",
    value: function recipes() {
      return new RecipesEndpoint(this);
    }
  }, {
    key: "skins",
    value: function skins() {
      return new SkinsEndpoint(this);
    }
  }, {
    key: "titles",
    value: function titles() {
      return new TitlesEndpoint(this);
    }
  }, {
    key: "transactions",
    value: function transactions() {
      return new CommerceEndpoint(this).transactions();
    }
  }, {
    key: "wallet",
    value: function wallet() {
      return new WalletEndpoint(this);
    } // All data available for the account in a single object

  }, {
    key: "blob",
    value: function blob() {
      return accountBlob(this);
    }
  }]);

  return AccountEndpoint;
}(AbstractEndpoint);

var AchievementsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint2) {
  "use strict";

  _inherits(AchievementsEndpoint, _AbstractEndpoint2);

  function AchievementsEndpoint(client) {
    var _this5;

    _classCallCheck(this, AchievementsEndpoint);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(AchievementsEndpoint).call(this, client));
    _this5.url = '/v2/account/achievements';
    _this5.isAuthenticated = true;
    _this5.isPaginated = true;
    _this5.isBulk = true;
    _this5.cacheTime = 5 * 60;
    return _this5;
  }

  _createClass(AchievementsEndpoint, [{
    key: "ids",
    value: function ids() {
      return Promise.reject(new Error('method not supported for this endpoint'));
    }
  }, {
    key: "get",
    value: function get(id) {
      if (id) {
        return _get(_getPrototypeOf(AchievementsEndpoint.prototype), "get", this).call(this, id);
      } // This endpoint returns all entries if the url gets requested
      // without any parameters, analogue to the other account endpoints


      return this.all();
    }
  }, {
    key: "all",
    value: function all() {
      return _get(_getPrototypeOf(AchievementsEndpoint.prototype), "get", this).call(this, '', true);
    }
  }]);

  return AchievementsEndpoint;
}(AbstractEndpoint);

var BankEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint3) {
  "use strict";

  _inherits(BankEndpoint, _AbstractEndpoint3);

  function BankEndpoint(client) {
    var _this6;

    _classCallCheck(this, BankEndpoint);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(BankEndpoint).call(this, client));
    _this6.url = '/v2/account/bank';
    _this6.isAuthenticated = true;
    _this6.cacheTime = 5 * 60;
    return _this6;
  }

  return BankEndpoint;
}(AbstractEndpoint);

var DungeonsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint4) {
  "use strict";

  _inherits(DungeonsEndpoint, _AbstractEndpoint4);

  function DungeonsEndpoint(client) {
    var _this7;

    _classCallCheck(this, DungeonsEndpoint);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(DungeonsEndpoint).call(this, client));
    _this7.url = '/v2/account/dungeons';
    _this7.isAuthenticated = true;
    _this7.cacheTime = 5 * 60;
    return _this7;
  }

  return DungeonsEndpoint;
}(AbstractEndpoint);

var DyesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint5) {
  "use strict";

  _inherits(DyesEndpoint, _AbstractEndpoint5);

  function DyesEndpoint(client) {
    var _this8;

    _classCallCheck(this, DyesEndpoint);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(DyesEndpoint).call(this, client));
    _this8.url = '/v2/account/dyes';
    _this8.isAuthenticated = true;
    _this8.cacheTime = 5 * 60;
    return _this8;
  }

  return DyesEndpoint;
}(AbstractEndpoint);

var FinishersEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint6) {
  "use strict";

  _inherits(FinishersEndpoint, _AbstractEndpoint6);

  function FinishersEndpoint(client) {
    var _this9;

    _classCallCheck(this, FinishersEndpoint);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(FinishersEndpoint).call(this, client));
    _this9.url = '/v2/account/finishers';
    _this9.isAuthenticated = true;
    _this9.cacheTime = 5 * 60;
    return _this9;
  }

  return FinishersEndpoint;
}(AbstractEndpoint);

var GlidersEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint7) {
  "use strict";

  _inherits(GlidersEndpoint, _AbstractEndpoint7);

  function GlidersEndpoint(client) {
    var _this10;

    _classCallCheck(this, GlidersEndpoint);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(GlidersEndpoint).call(this, client));
    _this10.url = '/v2/account/gliders';
    _this10.isAuthenticated = true;
    _this10.cacheTime = 5 * 60;
    return _this10;
  }

  return GlidersEndpoint;
}(AbstractEndpoint);

var HomeCatsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint8) {
  "use strict";

  _inherits(HomeCatsEndpoint, _AbstractEndpoint8);

  function HomeCatsEndpoint(client) {
    var _this11;

    _classCallCheck(this, HomeCatsEndpoint);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(HomeCatsEndpoint).call(this, client));
    _this11.url = '/v2/account/home/cats';
    _this11.isAuthenticated = true;
    _this11.cacheTime = 5 * 60;
    return _this11;
  }

  return HomeCatsEndpoint;
}(AbstractEndpoint);

var HomeNodesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint9) {
  "use strict";

  _inherits(HomeNodesEndpoint, _AbstractEndpoint9);

  function HomeNodesEndpoint(client) {
    var _this12;

    _classCallCheck(this, HomeNodesEndpoint);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(HomeNodesEndpoint).call(this, client));
    _this12.url = '/v2/account/home/nodes';
    _this12.isAuthenticated = true;
    _this12.cacheTime = 5 * 60;
    return _this12;
  }

  return HomeNodesEndpoint;
}(AbstractEndpoint);

var InventoryEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint10) {
  "use strict";

  _inherits(InventoryEndpoint, _AbstractEndpoint10);

  function InventoryEndpoint(client) {
    var _this13;

    _classCallCheck(this, InventoryEndpoint);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(InventoryEndpoint).call(this, client));
    _this13.url = '/v2/account/inventory';
    _this13.isAuthenticated = true;
    _this13.cacheTime = 5 * 60;
    return _this13;
  }

  return InventoryEndpoint;
}(AbstractEndpoint);

var MailcarriersEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint11) {
  "use strict";

  _inherits(MailcarriersEndpoint, _AbstractEndpoint11);

  function MailcarriersEndpoint(client) {
    var _this14;

    _classCallCheck(this, MailcarriersEndpoint);

    _this14 = _possibleConstructorReturn(this, _getPrototypeOf(MailcarriersEndpoint).call(this, client));
    _this14.url = '/v2/account/mailcarriers';
    _this14.isAuthenticated = true;
    _this14.cacheTime = 5 * 60;
    return _this14;
  }

  return MailcarriersEndpoint;
}(AbstractEndpoint);

var MasteriesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint12) {
  "use strict";

  _inherits(MasteriesEndpoint, _AbstractEndpoint12);

  function MasteriesEndpoint(client) {
    var _this15;

    _classCallCheck(this, MasteriesEndpoint);

    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(MasteriesEndpoint).call(this, client));
    _this15.url = '/v2/account/masteries';
    _this15.isAuthenticated = true;
    _this15.cacheTime = 5 * 60;
    return _this15;
  }

  return MasteriesEndpoint;
}(AbstractEndpoint);

var MasteryPointsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint13) {
  "use strict";

  _inherits(MasteryPointsEndpoint, _AbstractEndpoint13);

  function MasteryPointsEndpoint(client) {
    var _this16;

    _classCallCheck(this, MasteryPointsEndpoint);

    _this16 = _possibleConstructorReturn(this, _getPrototypeOf(MasteryPointsEndpoint).call(this, client));
    _this16.url = '/v2/account/mastery/points';
    _this16.isAuthenticated = true;
    _this16.cacheTime = 5 * 60;
    return _this16;
  }

  return MasteryPointsEndpoint;
}(AbstractEndpoint);

var MaterialsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint14) {
  "use strict";

  _inherits(MaterialsEndpoint, _AbstractEndpoint14);

  function MaterialsEndpoint(client) {
    var _this17;

    _classCallCheck(this, MaterialsEndpoint);

    _this17 = _possibleConstructorReturn(this, _getPrototypeOf(MaterialsEndpoint).call(this, client));
    _this17.url = '/v2/account/materials';
    _this17.isAuthenticated = true;
    _this17.cacheTime = 5 * 60;
    return _this17;
  }

  return MaterialsEndpoint;
}(AbstractEndpoint);

var MinisEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint15) {
  "use strict";

  _inherits(MinisEndpoint, _AbstractEndpoint15);

  function MinisEndpoint(client) {
    var _this18;

    _classCallCheck(this, MinisEndpoint);

    _this18 = _possibleConstructorReturn(this, _getPrototypeOf(MinisEndpoint).call(this, client));
    _this18.url = '/v2/account/minis';
    _this18.isAuthenticated = true;
    _this18.cacheTime = 5 * 60;
    return _this18;
  }

  return MinisEndpoint;
}(AbstractEndpoint);

var MountSkinsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint16) {
  "use strict";

  _inherits(MountSkinsEndpoint, _AbstractEndpoint16);

  function MountSkinsEndpoint(client) {
    var _this19;

    _classCallCheck(this, MountSkinsEndpoint);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(MountSkinsEndpoint).call(this, client));
    _this19.url = '/v2/account/mounts/skins';
    _this19.isAuthenticated = true;
    _this19.cacheTime = 5 * 60;
    return _this19;
  }

  return MountSkinsEndpoint;
}(AbstractEndpoint);

var MountTypesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint17) {
  "use strict";

  _inherits(MountTypesEndpoint, _AbstractEndpoint17);

  function MountTypesEndpoint(client) {
    var _this20;

    _classCallCheck(this, MountTypesEndpoint);

    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(MountTypesEndpoint).call(this, client));
    _this20.url = '/v2/account/mounts/types';
    _this20.isAuthenticated = true;
    _this20.cacheTime = 5 * 60;
    return _this20;
  }

  return MountTypesEndpoint;
}(AbstractEndpoint);

var OutfitsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint18) {
  "use strict";

  _inherits(OutfitsEndpoint, _AbstractEndpoint18);

  function OutfitsEndpoint(client) {
    var _this21;

    _classCallCheck(this, OutfitsEndpoint);

    _this21 = _possibleConstructorReturn(this, _getPrototypeOf(OutfitsEndpoint).call(this, client));
    _this21.url = '/v2/account/outfits';
    _this21.isAuthenticated = true;
    _this21.cacheTime = 5 * 60;
    return _this21;
  }

  return OutfitsEndpoint;
}(AbstractEndpoint);

var RaidsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint19) {
  "use strict";

  _inherits(RaidsEndpoint, _AbstractEndpoint19);

  function RaidsEndpoint(client) {
    var _this22;

    _classCallCheck(this, RaidsEndpoint);

    _this22 = _possibleConstructorReturn(this, _getPrototypeOf(RaidsEndpoint).call(this, client));
    _this22.url = '/v2/account/raids';
    _this22.isAuthenticated = true;
    _this22.cacheTime = 5 * 60;
    return _this22;
  }

  return RaidsEndpoint;
}(AbstractEndpoint);

var RecipesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint20) {
  "use strict";

  _inherits(RecipesEndpoint, _AbstractEndpoint20);

  function RecipesEndpoint(client) {
    var _this23;

    _classCallCheck(this, RecipesEndpoint);

    _this23 = _possibleConstructorReturn(this, _getPrototypeOf(RecipesEndpoint).call(this, client));
    _this23.url = '/v2/account/recipes';
    _this23.isAuthenticated = true;
    _this23.cacheTime = 5 * 60;
    return _this23;
  }

  return RecipesEndpoint;
}(AbstractEndpoint);

var SkinsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint21) {
  "use strict";

  _inherits(SkinsEndpoint, _AbstractEndpoint21);

  function SkinsEndpoint(client) {
    var _this24;

    _classCallCheck(this, SkinsEndpoint);

    _this24 = _possibleConstructorReturn(this, _getPrototypeOf(SkinsEndpoint).call(this, client));
    _this24.url = '/v2/account/skins';
    _this24.isAuthenticated = true;
    _this24.cacheTime = 5 * 60;
    return _this24;
  }

  return SkinsEndpoint;
}(AbstractEndpoint);

var TitlesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint22) {
  "use strict";

  _inherits(TitlesEndpoint, _AbstractEndpoint22);

  function TitlesEndpoint(client) {
    var _this25;

    _classCallCheck(this, TitlesEndpoint);

    _this25 = _possibleConstructorReturn(this, _getPrototypeOf(TitlesEndpoint).call(this, client));
    _this25.url = '/v2/account/titles';
    _this25.isAuthenticated = true;
    _this25.cacheTime = 5 * 60;
    return _this25;
  }

  return TitlesEndpoint;
}(AbstractEndpoint);

var WalletEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint23) {
  "use strict";

  _inherits(WalletEndpoint, _AbstractEndpoint23);

  function WalletEndpoint(client) {
    var _this26;

    _classCallCheck(this, WalletEndpoint);

    _this26 = _possibleConstructorReturn(this, _getPrototypeOf(WalletEndpoint).call(this, client));
    _this26.url = '/v2/account/wallet';
    _this26.isAuthenticated = true;
    _this26.cacheTime = 5 * 60;
    return _this26;
  }

  return WalletEndpoint;
}(AbstractEndpoint);